import {attr, controller, target} from '@github/catalyst'
import type {AutoCheckElement} from '@github/auto-check-element'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

@controller
export class SignupFormElement extends HTMLElement {
  @attr declare socialInfoUrl: string
  @attr declare socialRedirectUrl: string
  @attr declare startWithCaptcha: string
  @attr declare suggestedUsername: string
  @target declare SocialEmailSpan: HTMLElement
  @target declare LoginTextfield: HTMLInputElement
  @target declare AutoCheckLogin: AutoCheckElement
  @target declare SocialDifferentAccountLink: HTMLAnchorElement
  @target declare SignupButton: HTMLButtonElement

  async connectedCallback() {
    if (!this.SocialEmailSpan || !this.LoginTextfield) return

    const socialSignupInfo = await this.#fetchSocialSignupInfo()

    if (!socialSignupInfo || !socialSignupInfo.email || !socialSignupInfo.suggested_username) {
      window.location.replace(this.socialRedirectUrl)
    } else {
      this.SocialEmailSpan.textContent = socialSignupInfo.email
      this.suggestedUsername = socialSignupInfo.suggested_username
    }

    if (this.LoginTextfield && this.suggestedUsername) {
      this.LoginTextfield.value = this.suggestedUsername
      if (!this.startWithCaptcha) {
        this.LoginTextfield.focus()
        this.AutoCheckLogin.triggerValidation()
      }
    }

    if (
      this.SocialDifferentAccountLink &&
      socialSignupInfo.provider &&
      this.isValidProvider(socialSignupInfo.provider)
    ) {
      const socialAccountText = `Use a different ${socialSignupInfo.provider} account`
      this.SocialDifferentAccountLink.hidden = false
      this.SocialDifferentAccountLink.textContent = socialAccountText
      this.SocialDifferentAccountLink.ariaLabel = socialAccountText
    }

    if (this.startWithCaptcha && this.SignupButton) {
      this.SignupButton.click()
      this.hidden = false
    }
  }

  async #fetchSocialSignupInfo() {
    if (!this.socialInfoUrl) {
      window.location.replace(this.socialRedirectUrl)
    }

    try {
      const response = await verifiedFetchJSON(this.socialInfoUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
      })
      if (!response.ok) {
        window.location.replace(this.socialRedirectUrl)
      }
      const data = await response.json()
      return data
    } catch {
      window.location.replace(this.socialRedirectUrl)
    }
  }

  isValidProvider(provider: string): boolean {
    const validProviders = ['google', 'apple']
    return validProviders.includes(provider.toLowerCase())
  }
}
